<div class="tab-pane" role="tabpanel" id="Registro_bienes">
    <fieldset id="agregar_registro" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <div class="form-group" style="padding-bottom: 50px">
                                <label for="antep">Para Anteproyectos de Condominio Tipo B</label>
                            </div>
                            <div class="form-group col-md-12">   
                                <label for="inscrito" class="col-md-3" style="padding-top: 22px">Superficie Total de Terreno</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="superficie" id="superficie" name="superficie" formControlName="superficie" (change)="add_anteproy_condominio()" >
                                        <span matSuffix>m²</span>
                                    </mat-form-field>
                                </div>
                                <label for="fecha" class="col-md-3"  style="padding-top: 22px">Cantidad de Sitios Resultantes</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Cantidad" id="cantidad" name="cantidad" formControlName="cantidad" (change)="add_anteproy_condominio()" >
                                    </mat-form-field>
                                </div>
                            </div>
                           
                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>